import React from 'react';
import PropTypes from 'prop-types';
import { costFormatter } from '@format/currency';
import {
  Price,
  PriceBeforeDiscount,
  StyledAmountInfo,
  SaveText,
} from './styles';

export const Pricing = ({
  discountedPrice,
  price,
  period,
  message,
  savePercent,
}) => {
  // If there's no discountedPrice and no message, render nothing
  if (discountedPrice == null && !message) {
    return null;
  }
  const formatPrice = price => {
    if (typeof price === 'string' && price.startsWith('$')) {
      return price;
    }
    if (price == null || price === '' || isNaN(price)) {
      return '';
    }

    const parsedPrice = parseFloat(price);

    if (isNaN(parsedPrice)) {
      return '';
    }

    return costFormatter(parsedPrice);
  };

  const formattedPrice = price != null ? formatPrice(price) : message || 'FREE';
  const formattedDiscountedPrice =
    discountedPrice != null ? formatPrice(discountedPrice) : message || 'FREE';

  return (
    <>
      {formattedDiscountedPrice !== 'FREE' && !message ? (
        <StyledAmountInfo>
          <PriceBeforeDiscount>{formattedPrice}</PriceBeforeDiscount>
          <Price>
            {formattedDiscountedPrice}
            {formattedDiscountedPrice && period && `/${period}`}
            {message}
            {savePercent && <SaveText>{savePercent}</SaveText>}
          </Price>
        </StyledAmountInfo>
      ) : (
        <StyledAmountInfo>
          <Price>{formattedDiscountedPrice}</Price>
        </StyledAmountInfo>
      )}
    </>
  );
};

Pricing.propTypes = {
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  discountedPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  period: PropTypes.string,
  message: PropTypes.string,
  savePercent: PropTypes.string,
};
